import {
  MdOutlineDomain,
  MdOutlineGppGood,
  MdOutlineHome,
  MdOutlinePool
} from 'react-icons/md'

const DefaultSearches = () => {
  return (
    <div>
      <p className="text-xs text-[#898CA8]">Estoy buscando</p>

      <div className="grid grid-cols-2 gap-y-2 gap-x-4 mt-2.5">
        <button
          type="button"
          className="flex justify-center items-center gap-1 p-2 bg-button-gray-01 rounded-lg"
        >
          <MdOutlineDomain className="w-[18px] h-[18px] text-text-primary" />

          <p className="text-xs text-text-primary font-bold truncate">CDMX</p>
        </button>

        <button
          type="button"
          className="flex justify-center items-center gap-1 p-2 bg-button-gray-01 rounded-lg"
        >
          <MdOutlineHome className=" w-[18px] h-[18px] text-text-primary" />
          <p className="text-xs text-text-primary font-bold truncate">
            Colonia Roma
          </p>
        </button>

        <button
          type="button"
          className="flex justify-center items-center gap-1 p-2 bg-button-gray-01 rounded-lg"
        >
          <MdOutlineGppGood className=" w-[18px] h-[18px] text-text-primary" />
          <p className="text-xs text-text-primary font-bold truncate">
            Seguridad Privada
          </p>
        </button>

        <button
          type="button"
          className="flex justify-center items-center gap-1 p-2 bg-button-gray-01 rounded-lg"
        >
          <MdOutlinePool className=" w-[18px] h-[18px] text-text-primary" />

          <p className="text-xs text-text-primary font-bold truncate">
            Alberca
          </p>
        </button>
      </div>
    </div>
  )
}

export default DefaultSearches
